"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSearchDisabled = exports.mapAircraftToOption = exports.changeStopover = exports.swapOrder = exports.swapLocations = exports.mapAirportToOption = exports.getDestinationToDepartureLabel = exports.getDatesLabel = exports.getPassengerText = exports.formatDate = exports.getSearchInfo = void 0;
const moment_1 = __importDefault(require("moment"));
const getSearchInfo = ({ count, startDate, endDate, t }) => {
    let info = ``;
    if (count == 0) {
        if (!startDate)
            info = t("no_flights");
        else if (!endDate)
            info = `${startDate} (${t("no_flights")})`;
        else
            info = `${t("since")} ${startDate} ${t("to").toLowerCase()} ${endDate} (${t("no_flights")})`;
    }
    if (count == 1) {
        if (!startDate)
            info = `${count} ${t("flight")}`;
        else if (!endDate)
            info = `${startDate} (${count} ${t("flight")})`;
        else
            info = `${t("since")} ${startDate} ${t("to").toLowerCase()} ${endDate} (${count} ${t("flight")})`;
    }
    if (count >= 2 && count <= 4) {
        if (!startDate)
            info = `${count} ${t("flights")}`;
        else if (!endDate)
            info = `${startDate} (${count} ${t("flights")})`;
        else
            info = `${t("since")} ${startDate} ${t("to").toLowerCase()} ${endDate} (${count} ${t("flights")})`;
    }
    if (count >= 5) {
        if (!startDate)
            info = `${count} ${t("more_flights")}`;
        else if (!endDate)
            info = `${startDate} (${count} ${t("more_flights")})`;
        else
            info = `${t("since")} ${startDate} ${t("to").toLowerCase()} ${endDate} (${count} ${t("more_flights")})`;
    }
    return info;
};
exports.getSearchInfo = getSearchInfo;
const formatDate = (date) => {
    let newDate = (0, moment_1.default)(date);
    return newDate.calendar(null, {
        sameDay: 'YYYY-MM-DD',
        nextDay: 'YYYY-MM-DD',
        nextWeek: "YYYY-MM-DD",
        sameElse: 'YYYY-MM-DD'
    });
};
exports.formatDate = formatDate;
const getPassengerText = (passengersCount, t) => {
    if (!passengersCount)
        return "";
    else if (passengersCount == 1)
        return `${passengersCount} ${t("passenger").toLowerCase()}`;
    else
        return `${passengersCount} ${t("passengers").toLowerCase()}`;
};
exports.getPassengerText = getPassengerText;
const getDatesLabel = (startDate, endDate) => {
    if (!startDate)
        return "";
    else if (!endDate)
        return `${startDate}, `;
    else
        return `${startDate} - ${endDate}, `;
};
exports.getDatesLabel = getDatesLabel;
const getDestinationToDepartureLabel = (departureAirport, destinationAirport, country, t) => {
    let label = '';
    if (departureAirport)
        label += `${departureAirport.city}${country ? `, ${departureAirport.country} > ` : " > "}`;
    else
        label += `${t('anywhere')} > `;
    if (destinationAirport)
        label += `${destinationAirport.city}${country ? `, ${destinationAirport.country}` : ""}`;
    else
        label += t('anywhere');
    return label;
};
exports.getDestinationToDepartureLabel = getDestinationToDepartureLabel;
const mapAirportToOption = (airport) => ({
    ...airport,
    label: `${airport.city}, ${airport.name}, ${airport.country}${airport.iata || airport.icao ? ` (${airport.iata || airport.icao})` : ''}`,
    value: airport.id
});
exports.mapAirportToOption = mapAirportToOption;
const swapLocations = ({ departureAirport, destinationAirport, onDepartureAirportChange, onDestinationAirportChange, rotate }) => {
    rotate();
    const tempDepartureAirport = departureAirport;
    onDepartureAirportChange(destinationAirport);
    onDestinationAirportChange(tempDepartureAirport);
};
exports.swapLocations = swapLocations;
const swapOrder = ({ departureAirport, destinationAirport, onDepartureAirportChange, onDestinationAirportChange, rotate, stopovers, changeStopovers }) => {
    (0, exports.swapLocations)({
        departureAirport,
        destinationAirport,
        onDepartureAirportChange,
        onDestinationAirportChange,
        rotate
    });
    if (stopovers && changeStopovers) {
        const updatedStopovers = [...stopovers];
        changeStopovers(updatedStopovers.reverse());
    }
};
exports.swapOrder = swapOrder;
const changeStopover = (text, index, stopovers, changeStopovers) => {
    const updatedStopovers = [...stopovers];
    updatedStopovers[index] = text;
    changeStopovers(updatedStopovers);
};
exports.changeStopover = changeStopover;
const mapAircraftToOption = (aircraft) => ({
    ...aircraft,
    label: aircraft.reg_number,
    value: aircraft.id
});
exports.mapAircraftToOption = mapAircraftToOption;
const isSearchDisabled = (data) => !data.destinationAirport && !data.departureAirport && !data.startDate && !data.passengers;
exports.isSearchDisabled = isSearchDisabled;
